export const HUBS = ['marketingLevel', 'salesLevel', 'commerceLevel', 'serviceLevel', 'contentLevel', 'operationsLevel'];
export const HUB_LEVELS = ['FREE', 'STARTER', 'PRO', 'ENTERPRISE'];
export const ALL_FEATURE_TYPES = ['CRM_CUSTOMIZATION', 'CRM_RECORDS', 'SALES_HUB', 'SERVICE_HUB', 'MARKETING_HUB'];